// Branded 404 — editorial typography in the house style.
//
// Note: this catches React Router-level 404s (errorElement) and the catch-all
// path. If the URL was `/i/<slug>` and the slug 404s on the API, GuestPage
// shows its own error UI; this page does not handle that case.

import "@/styles/tk-pages.css";
import { Link, useRouteError } from "react-router-dom";
import { useT } from "@/lib/i18n";
import { ArchFrame, Eyebrow, MinimalHeader, Sparkle } from "@/components/tk";

export function NotFoundPage() {
  const t = useT();
  // As the router's errorElement this renders in place of RootLayout, so it
  // brings its own app shell and header.
  const standalone = useRouteError() != null;
  const page = (
    <div className="tk-pages-404">
      <div className="tk-container tk-pages-404__inner">
        <ArchFrame className="tk-pages-404__arch">
          <div className="tk-pages-404__art">
            <Sparkle size={14} />
            <span className="tk-pages-404__num" aria-hidden="true">404</span>
            <Eyebrow sparkles="none">{t("notfound.eyebrow")}</Eyebrow>
          </div>
        </ArchFrame>

        <h1 className="tk-h2 tk-pages-404__title">
          {t("tk.pages.notfound.title_1")} <em>{t("tk.pages.notfound.title_2")}</em>
        </h1>

        <p className="tk-pages-404__lead">{t("notfound.body")}</p>

        <div className="tk-pages-404__actions">
          <Link to="/" className="tk-btn tk-btn--primary">
            {t("notfound.home")}
          </Link>
          <Link to="/templates" className="tk-btn tk-btn--secondary">
            {t("notfound.gallery")}
          </Link>
        </div>
      </div>
    </div>
  );

  if (!standalone) return page;
  return (
    <div className="tk-app tk-pages-shell">
      <MinimalHeader />
      <main>{page}</main>
    </div>
  );
}
